import Tools from '../Tools/Tools';
/**
 * Tato třída spravuje modální okna.
 * @example
 *  let modal = new ModalWindow();
 *
 *	<button class="Modal-open" data-id="modal37">Otevřít</button>
 *	<div id="modal37" class="Modal Modal--default is-hidden">
 *		<button class="Modal-close">&times;</button>
 *		<h1>Nadpis</h1>
 *		<p>Lorem ipsum</p>
 *	</div>
 */
class ModalWindow {
	constructor() {
		Tools.addListener(document.querySelectorAll('.Modal-open'), 'click', this._openByClick.bind(this));
	}

	/**
	 * Funkce, která se volá při zavření modálního okna.
	 * @param {function} func
	 */
	setOnCloseFunc(func) {
		this.onClose = func;
	}

	/**
	 * Otevře modální okno.
	 * @param {Element} container
	 */
	openByCustomEvent(container) {
		this.modal = container;
		this._open();
	}

	/**
	 * Funkce zobrazuje (otevírá) modální okno, pokud uživatel klikne
	 * na tlačítko s třídou 'Modal-open'.
	 * @param {Event} e - Objekt obsahující událost.
	 */
	_openByClick(e) {
		this.modal = this._getModalContainer(e);
		this._open();
	}

	/**
	 * Otevře modální okno a nastaví listener pro jeho zavření.
	 */
	_open() {
		this.overlayDiv = this._getOverlayDiv();

		this.closeButtons = this.modal.querySelectorAll('.Modal-close');
		this.closeListener = this.close.bind(this);
		Tools.addListener(this.closeButtons, 'click', this.closeListener);

		let offsetFromTop = (window.innerHeight - this.modal.clientHeight) / 2;

		offsetFromTop = offsetFromTop < 0 ? 0 : offsetFromTop;
		// eslint-disable-next-line typescript-eslint/restrict-template-expressions
		this.modal.style.top = `calc(${offsetFromTop}px + ${window.scrollY}px)`;

		this.modal.classList.remove('is-hidden');
		this.modal.classList.add('is-visible');
	}

	/**
	 * Vytvoří/zobrazí DIV překrívající celou stránku.
	 * @return {Element}
	 */
	_getOverlayDiv() {
		let overlayDiv = null;

		if (
			this.modal.nextElementSibling &&
			this.modal.nextElementSibling.classList && // in case when sibling is text
			this.modal.nextElementSibling.classList.contains('Modal-overlay')
		) {
			overlayDiv = this.modal.nextElementSibling;
			overlayDiv.classList.remove('is-hidden');
			overlayDiv.classList.add('is-visible');
		} else if (
			this.modal.previousSibling &&
			this.modal.previousSibling.classList && // in case when sibling is text
			this.modal.previousSibling.classList.contains('Modal-overlay')
		) {
			overlayDiv = this.modal.previousSibling;
			overlayDiv.classList.remove('is-hidden');
			overlayDiv.classList.add('is-visible');
		} else {
			overlayDiv = Tools.createElement('div', {
				class: 'Modal-overlay is-visible',
			});

			this.modal.parentNode.insertBefore(overlayDiv, this.modal.nextSibling);
		}

		return overlayDiv;
	}

	/**
	 * Tlačítko pro otevírání modálního okna musí obsahovat "data-id",
	 * které odkazuje na element, jenž obsahuje modální okno.
	 * @param {Event} e
	 * @return {Element}
	 */
	_getModalContainer(e) {
		const id = e.target.getAttribute('data-id');

		return document.getElementById(id);
	}

	/**
	 * Funkce skrývá (zavírá) modální okno.
	 */
	close() {
		this.modal.classList.remove('is-visible');
		this.modal.classList.add('is-hidden');
		Tools.removeListener(this.closeButtons, 'click', this.closeListener);
		this.closeListener = null;

		this.overlayDiv.classList.add('is-hidden');
		this.overlayDiv.classList.remove('is-visible');

		if (this.onClose) {
			this.onClose();
		}
	}
}

export default ModalWindow;
